import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Navbar from "@/Common/Navbar";

import config from "./../config";

const API_BASE_URL = config.API_BASE_URL;

const MembersList = () => {
  const [members, setMembers] = useState([]);
  const [showAddForm, setShowAddForm] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
    first_name: "",
    last_name: "",
  });

  const [editMemberId, setEditMemberId] = useState(null);
  const [editFormData, setEditFormData] = useState({
    first_name: "",
    last_name: "",
  });

  const navigate = useNavigate();
  const token = localStorage.getItem("authToken");

  useEffect(() => {
    fetchMembers();
  }, []);

  const fetchMembers = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/users/members/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setMembers(response.data);
    } catch (error) {
      toast.error("Failed to fetch members.");
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this member?")) {
      try {
        await axios.delete(`${API_BASE_URL}/api/users/members/${id}/delete/`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        toast.success("Member deleted.");
        fetchMembers();
      } catch (error) {
        toast.error("Failed to delete member.");
      }
    }
  };

  const handleAddMember = async (e) => {
    e.preventDefault();
    try {
      await axios.post(
        `${API_BASE_URL}/api/users/members/add/`,
        {
          users: [
            {
              ...formData,
              is_active: true,
            },
          ],
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast.success("Member added successfully!");
      setShowAddForm(false);
      setFormData({ email: "", first_name: "", last_name: "" });
      fetchMembers();
    } catch (error) {
      toast.error("Failed to add member.");
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <div className="flex min-h-screen bg-gradient-to-br from-theme-primary to-theme-secondary text-white">
      <Navbar />

      <div className="flex-1 p-8 mt-20 ml-12">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-bold bg-gradient-to-r from-blue-400 via-purple-500 to-indigo-500 bg-clip-text text-transparent uppercase tracking-wide">
            Members{" "}
            <span className="bg-indigo-900 text-indigo-400 rounded-full px-2 text-sm">
              {members.length}
            </span>
          </h2>
          <button
            onClick={() => setShowAddForm(true)}
            className="bg-indigo-600 hover:bg-indigo-700 text-white px-6 py-2 rounded-md font-semibold transition-all duration-300"
          >
            Add Member
          </button>
        </div>

        <div className="bg-zinc-900 shadow-md rounded-lg overflow-hidden">
          <table className="min-w-full table-auto">
            <thead className="bg-zinc-800">
              <tr>
                <th className="text-left px-6 py-3 text-sm font-semibold text-indigo-400">
                  Email
                </th>
                <th className="text-left px-6 py-3 text-sm font-semibold text-indigo-400">
                  First Name
                </th>
                <th className="text-left px-6 py-3 text-sm font-semibold text-indigo-400">
                  Last Name
                </th>
                <th className="text-left px-6 py-3 text-sm font-semibold text-indigo-400">
                  Active
                </th>
                <th className="text-left px-6 py-3 text-sm font-semibold text-indigo-400">
                  Email Verified
                </th>
                <th className="text-left px-6 py-3 text-sm font-semibold text-indigo-400">
                  Created On
                </th>
                <th className="text-left px-6 py-3 text-sm font-semibold text-indigo-400">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {members.map((member) => (
                <tr key={member.id} className="border-t border-zinc-700">
                  <td className="px-6 py-4">{member.email}</td>
                  <td className="px-6 py-4">
                    {editMemberId === member.id ? (
                      <input
                        type="text"
                        name="first_name"
                        value={editFormData.first_name}
                        onChange={(e) =>
                          setEditFormData({
                            ...editFormData,
                            first_name: e.target.value,
                          })
                        }
                        className="bg-zinc-800 border border-indigo-600 text-indigo-200 placeholder-indigo-400 rounded w-full px-2 py-1 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                      />
                    ) : (
                      member.first_name
                    )}
                  </td>
                  <td className="px-6 py-4">
                    {editMemberId === member.id ? (
                      <input
                        type="text"
                        name="last_name"
                        value={editFormData.last_name}
                        onChange={(e) =>
                          setEditFormData({
                            ...editFormData,
                            last_name: e.target.value,
                          })
                        }
                        className="bg-zinc-800 border border-indigo-600 text-indigo-200 placeholder-indigo-400 rounded w-full px-2 py-1 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                      />
                    ) : (
                      member.last_name
                    )}
                  </td>

                  <td className="px-6 py-4">{member.active ? "Enabled" : "Disabled"}</td>
                  <td className="px-6 py-4">{member.email_verified ? "Verified" : "Not Verified"}</td>
                  <td className="px-6 py-4">{member.created_on}</td>
                  <td className="px-6 py-4 flex gap-2">
                    {editMemberId === member.id ? (
                      <button
                        onClick={async () => {
                          try {
                            await axios.put(
                              `http://127.0.0.1:8000/api/users/members/${member.id}/edit/`,
                              editFormData,
                              {
                                headers: { Authorization: `Bearer ${token}` },
                              }
                            );
                            toast.success("Member updated.");
                            setEditMemberId(null);
                            fetchMembers();
                          } catch (error) {
                            toast.error("Failed to update member.");
                          }
                        }}
                        className="bg-green-600 hover:bg-green-700 text-white px-4 py-1 rounded-md text-sm transition-colors duration-300"
                      >
                        Save
                      </button>
                    ) : (
                      <button
                        onClick={() => {
                          setEditMemberId(member.id);
                          setEditFormData({
                            first_name: member.first_name,
                            last_name: member.last_name,
                          });
                        }}
                        className="bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-1 rounded-md text-sm transition-colors duration-300"
                      >
                        Edit
                      </button>
                    )}

                    <button
                      onClick={() => handleDelete(member.id)}
                      className="bg-red-600 hover:bg-red-700 text-white px-4 py-1 rounded-md text-sm transition-colors duration-300"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
              {members.length === 0 && (
                <tr>
                  <td colSpan="7" className="text-center py-6 text-indigo-400">
                    No members found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Add Member Drawer */}
      {showAddForm && (
        <div className="fixed top-16 right-0 h-full w-96 bg-zinc-900 shadow-lg p-8 overflow-auto transition-transform duration-300 rounded-l-md">
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-2xl font-bold bg-gradient-to-r from-blue-400 via-purple-500 to-indigo-500 bg-clip-text text-transparent uppercase tracking-wide">
              Add Member
            </h2>
            <button
              onClick={() => setShowAddForm(false)}
              className="bg-zinc-800 text-indigo-300 px-4 py-2 rounded-md hover:bg-zinc-700 transition-colors duration-300"
            >
              Cancel
            </button>
          </div>
          <form onSubmit={handleAddMember} className="space-y-6">
            <input
              type="email"
              name="email"
              placeholder="Email"
              value={formData.email}
              onChange={handleChange}
              required
              className="w-full p-3 bg-zinc-800 border border-indigo-600 rounded-md text-indigo-200 placeholder-indigo-400 focus:outline-none focus:ring-2 focus:ring-indigo-500"
            />
            <input
              type="text"
              name="first_name"
              placeholder="First Name"
              value={formData.first_name}
              onChange={handleChange}
              required
              className="w-full p-3 bg-zinc-800 border border-indigo-600 rounded-md text-indigo-200 placeholder-indigo-400 focus:outline-none focus:ring-2 focus:ring-indigo-500"
            />
            <input
              type="text"
              name="last_name"
              placeholder="Last Name"
              value={formData.last_name}
              onChange={handleChange}
              required
              className="w-full p-3 bg-zinc-800 border border-indigo-600 rounded-md text-indigo-200 placeholder-indigo-400 focus:outline-none focus:ring-2 focus:ring-indigo-500"
            />
            <button
              type="submit"
              className="w-full bg-indigo-600 hover:bg-indigo-700 text-white py-3 rounded-md font-semibold transition-colors duration-300"
            >
              Submit
            </button>
          </form>
        </div>
      )}
    </div>
  );
};

export default MembersList;